import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import * as moment from 'moment';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { allCountries } from '../../../countries';

import { AdminService } from 'src/app/services/admin/admin.service';
import { DatePipe } from '@angular/common';
import { MessagesService } from 'src/app/services/message/messages.service';
import { EventsService } from 'src/app/services/events/events.service';
import { adminType,planModel,licenseType, accountType , permissionLevel ,hostingList, tierist} from  '../../../data-tables';
import { NgxSpinnerService } from 'ngx-spinner';


@Component({
  selector: 'app-manager-create',
  templateUrl: './manager-create.component.html',
  styleUrls: ['./manager-create.component.less'],
  providers: [DatePipe]
})

export class ManagerCreateComponent implements OnInit {
    private managerForm: FormGroup;
    public listaccType;
    public listadminType;
    public listplanModel;
    public listlicenseType;
    public status = [true,false];
    public permissionLevel = permissionLevel;
    public hostingList = hostingList;
    public tierList =  tierist;
    public listOfAllCountries = allCountries;
    public passwordString = '';

    constructor(private fb: FormBuilder, private ngbActiveMod: NgbActiveModal, private admin: AdminService, private modal: NgbModal,private datePipe: DatePipe, private msg: MessagesService, private events: EventsService, private load: NgxSpinnerService) { }
    
    ngOnInit() {
        this.init();
      }
    
      private init(){
        this.listadminType = adminType;
        this.listplanModel = planModel;
        this.listlicenseType = licenseType;
        //this.listaccType = accountType;

        this.managerForm = this.fb.group({
          first_name: ['', Validators.compose([Validators.required, Validators.minLength(2)])],
          last_name: ['', [Validators.required, Validators.minLength(2)]],
          organisation: [''],
          country: ['', Validators.required],
          admin_id: ['', Validators.required],
          email: ['', [Validators.required, Validators.email]],
          mobile:[''],
          password: ['', [Validators.required, Validators.minLength(5)]],
          admin_type:['',[Validators.required]],
          plan_model:[''],
          sub_account_type: ['', Validators.required],
          sub_account_limit:['',Validators.required],
          permission_level: [''],
          start_date:['',Validators.required],
          expire_date:['',Validators.required],
          license_type:[''],
          installation_date:[''],
          remarks:[''],
          status:['',Validators.required],
          hosting:['',Validators.required],
        })
    }
      public getForm() {
        return this.managerForm;
      }
      public closeModal() {
        this.ngbActiveMod.close({ task: 'close modal', success: true });
      }
 // update template password written
      public updatePasswordWritten() {
      this.passwordString = this.managerForm.value.password;
    }

      public createManager(){
         //this.load.show();
         let formData = {
          first_name: this.managerForm.value.first_name,
          last_name:this.managerForm.value.last_name,
          organisation:this.managerForm.value.organisation,
          country: this.managerForm.value.country,
          admin_id:this.managerForm.value.admin_id,
          email: this.managerForm.value.email,
          mobile: this.managerForm.value.mobile,
          password: this.managerForm.value.password,
          admin_type:this.convertCodeType("adminType",this.managerForm.value.admin_type),
          plan_model:this.convertCodeType("planModel",this.managerForm.value.plan_model),
          sub_account_type:this.managerForm.value.sub_account_type,
          sub_account_limit:this.managerForm.value.sub_account_limit,
          permission_level:this.managerForm.value.permission_level,
          subscription_date:[moment(this.managerForm.value.start_date).toISOString(),moment(this.managerForm.value.expire_date).toISOString()],
          license_type:this.managerForm.value.license_type,
          installation_date:this.managerForm.value.installation_date,
          remarks:this.managerForm.value.remarks,
          status:this.managerForm.value.status,
          hosting: this.managerForm.value.hosting,
         }
        
         this.admin.createTheManager(formData)
         .then(msg => this.success(msg))
         .catch(err => this.error(err));

      }
      public onPlanModelChange(event){
        const selectedValue = (event.target as HTMLSelectElement).value;
        if(selectedValue == "Ecosystem Beginner" || selectedValue == "Enterprise Premise Beginner" || selectedValue == "Enterprise Cloud Beginner"){
           this.listaccType = ["beginner"];
        }
        else if(selectedValue == "Ecosystem Developer" || selectedValue == "Enterprise Premise Developer" || selectedValue == "Enterprise Cloud Developer"){
           this.listaccType = ["developer"];;
        }
      }


      private success(res) {
        this.load.hide();
        this.msg.success(res);
        this.resetField();
        this.closeModal();
      }
    
      // handle error
      private error(err) {
        this.load.hide();
        this.msg.error(err);
      }

      // resets form field
      private resetField() {
        this.managerForm.reset();
      }

      private convertCodeType(type,value){
          let output = "";
          switch(type){
            case "adminType":
              if(value == "Ecosystem"){
                output = "ECO";
                return output;
              }
              if(value == "Provider"){
                 output = "P";
                 return output;
              }
           break;
           case "planModel":
              if(value == "Ecosystem Beginner"){
                 output = "ECO-B";
                 return output;
              }
              if(value == "Ecosystem Developer"){
                 output = "ECO-D"
                 return output;
              }
              if(value == "Enterpise Premise Beginner"){
                 output = "ENTP-B";
                 return output;
              }
              if(value == "Enterprise Premise Developer"){
                 output = "ENTP-D";
                 return output;
              }
              if(value == "Enterpise Cloud Beginner"){
                output = "ENTC-B";
                return output;
              }
              if(value == "Enterprise Cloud Developer"){
                output = "ENTC-D";
                return output;
              }
           break;
          }
      }
      
}

